import { render, staticRenderFns } from "./SamMultiSelect.vue?vue&type=template&id=0871a6fb&scoped=true&"
import script from "./SamMultiSelect.vue?vue&type=script&lang=js&"
export * from "./SamMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./SamMultiSelect.vue?vue&type=style&index=0&id=0871a6fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871a6fb",
  null
  
)

export default component.exports